"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLastModifiedTemplateId = exports.getTemplatesBySearch = exports.getTemplateById = exports.getTemplates = exports.getHasErrors = exports.getErrors = exports.getIsLoading = exports.getIsLoaded = void 0;

var _ramda = require("ramda");

var _reselect = require("reselect");

var _utils = require("@alycecom/utils");

var pathToPersonalTemplateSettings = (0, _ramda.prop)('personalTemplateSettings');
var getIsLoaded = (0, _ramda.compose)((0, _ramda.prop)('isLoaded'), pathToPersonalTemplateSettings);
exports.getIsLoaded = getIsLoaded;
var getIsLoading = (0, _ramda.compose)((0, _ramda.prop)('isLoading'), pathToPersonalTemplateSettings);
exports.getIsLoading = getIsLoading;
var getErrors = (0, _ramda.compose)((0, _ramda.prop)('errors'), pathToPersonalTemplateSettings);
exports.getErrors = getErrors;
var getHasErrors = (0, _ramda.compose)((0, _ramda.compose)(_ramda.not, _ramda.isEmpty), getErrors);
exports.getHasErrors = getHasErrors;
var getTemplates = (0, _ramda.compose)((0, _ramda.prop)('templates'), pathToPersonalTemplateSettings);
exports.getTemplates = getTemplates;

var getTemplateById = function getTemplateById(templateId) {
  return (0, _ramda.compose)((0, _ramda.prop)(templateId), getTemplates);
};

exports.getTemplateById = getTemplateById;

var getTemplatesBySearch = function getTemplatesBySearch(search) {
  return (0, _reselect.createSelector)(getTemplates, (0, _ramda.compose)((0, _utils.objFromListWith)((0, _ramda.prop)('id')), (0, _ramda.filter)((0, _ramda.compose)((0, _ramda.includes)((0, _ramda.toLower)(search)), _ramda.toLower, (0, _ramda.prop)('name'))), _ramda.values));
};

exports.getTemplatesBySearch = getTemplatesBySearch;
var getLastModifiedTemplateId = (0, _ramda.compose)((0, _ramda.prop)('lastModifiedTemplateId'), pathToPersonalTemplateSettings);
exports.getLastModifiedTemplateId = getLastModifiedTemplateId;